import { render, staticRenderFns } from "./infoTrivia.vue?vue&type=template&id=6058ddfa&scoped=true&"
import script from "./infoTrivia.vue?vue&type=script&lang=js&"
export * from "./infoTrivia.vue?vue&type=script&lang=js&"
import style0 from "./infoTrivia.vue?vue&type=style&index=0&id=6058ddfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058ddfa",
  null
  
)

export default component.exports